import React from 'react';
import logo from '../../../images/lexus-logo-v2.svg';

const Header = ({ title }) => {
  return (
    <header className="lexus-header">
      <img src={logo} alt="Lexus Logo" style={{ width: '110px' }} />
    </header>
  );
};

export default Header;
